import React from 'react'

const Success = () => {
  return (
    <div className='bg-green-200 w-full max-w-md m-auto h-36 flex justify-center items-center font-semibold text-lg'>
        <p>Payment Successful !</p>
    </div>
  )
}

export default Success